import { isArrayWithLength } from './utils';

export const reject = (array, predicate) => {
  if (!isArrayWithLength(array) || typeof predicate !== 'function') {
    return array;
  }

  const item = array.find(predicate);

  if (!item) {
    return array;
  }

  const index = array.indexOf(item);

  if (index === -1) {
    return array;
  }

  if (index === 0) {
    return array.slice(1);
  }
  
  if (index === array.length - 1) {
    return array.slice(0, array.length - 1);
  }

  const first = array.slice(0, index);
  const rest = array.slice(index + 1, array.length);
  return first.concat(rest);
}

export const mergeNew = (original, newData, key) => {
  if(newData === undefined) {
    return original;
  } 
  else if (original === undefined) {
    return newData;
  }
  newData.forEach(data => {
    const foundIndex = original.findIndex(orig => orig[key] == data[key]);
    if (foundIndex >= 0) {
      original.splice(foundIndex, 1, data);
    } else {
      original.push(data);
    }
  });

  return original;
}